import React, { useEffect, useState, useRef } from "react";
import { Spinner, Form, Button } from "react-bootstrap";
import send_icon from "../images/send.png";
import { showToast as toast } from "../toastManager";
import errorMessages from "../errorMessages.js";
import axios from "axios";
import logo from '../images/scalex_ai_logo.png';
import "../ChatApp.css";


function ChatBotSuggestionGen({ ViewedPage, shop_domain, app_url }) {
	ViewedPage(24);

	// State to store the imported function
	const [sxi_customized_add_template_1_renderer, setRender_sxi_customized_add_template_1] = useState(null);
	const [sxi_customized_add_template_2_renderer, setRender_sxi_customized_add_template_2] = useState(null);
	const [sxi_customized_add_template_3_renderer, setRender_sxi_customized_add_template_3] = useState(null);
	const [sxi_customized_add_template_4_renderer, setRender_sxi_customized_add_template_4] = useState(null);
	const [sxi_customized_add_template_5_renderer, setRender_sxi_customized_add_template_5] = useState(null);
	const [sxi_customized_add_template_6_renderer, setRender_sxi_customized_add_template_6] = useState(null);
	const [sxi_customized_add_template_7_renderer, setRender_sxi_customized_add_template_7] = useState(null);

	// State to track loading status
	const [loading, setLoading] = useState(true);
	const [submit_btn_loading, setSubmitBtnLoading] = useState(false);
	const [show_chat_bot, setShowChatBot] = useState(false);
	const [input, setInput] = useState("");
	const [suggestions_gen_data, setSuggestionsGenData] = useState(
		sessionStorage.getItem(`${shop_domain.replace(".myshopify.com","")}_sugg_gen_msg`)
			? JSON.parse(sessionStorage.getItem(`${shop_domain.replace(".myshopify.com","")}_sugg_gen_msg`))
			: []
	);

	const inputRef = useRef(null);
	// Auto-grow the prompt textarea up to its CSS max-height as the user types / on clear
	useEffect(() => {
		const el = inputRef.current;
		if (!el) return;
		el.style.height = 'auto';
		el.style.height = `${el.scrollHeight}px`;
	}, [input]);

	useEffect(() => {
		// Set loading state
		setLoading(true);

		// Create <link> tag
		const link = document.createElement("link");
		link.rel = "stylesheet";
		link.href = `https://scalex-ai-existing-div-cdn.web.app/custom_div/style.css`;

		// Insert link at the top of <head>
		document.head.insertBefore(link, document.head.firstChild);

		// Create <script> tag
		const script = document.createElement("script");
		script.src = `https://scalex-ai-existing-div-cdn.web.app/custom_div/script.js`;
		script.async = true;

		// Handle successful loading
		script.onload = () => {
			// Check if the function is available in the global scope
			if (typeof window.sxi_customized_add_template_1 === "function") {
                setRender_sxi_customized_add_template_1(
                    () => window.sxi_customized_add_template_1
				);
			} 
            else {
                console.error("Template - 1 function not found in the loaded script");
            }

            if (typeof window.sxi_customized_add_template_2 === "function") {
                setRender_sxi_customized_add_template_2(
                    () => window.sxi_customized_add_template_2
                );
            }
            else {
				console.error("Template - 2 function not found in the loaded script");
			}

            if (typeof window.sxi_customized_add_template_3 === "function") {
                setRender_sxi_customized_add_template_3(
                    () => window.sxi_customized_add_template_3
                );
            }
            else {
				console.error("Template - 3 function not found in the loaded script");
			}

            if (typeof window.sxi_customized_add_template_4 === "function") {
                setRender_sxi_customized_add_template_4(
                    () => window.sxi_customized_add_template_4
                );
            }
            else {
				console.error("Template - 4 function not found in the loaded script");
			}

            if (typeof window.sxi_customized_add_template_5 === "function") {
                setRender_sxi_customized_add_template_5(
                    () => window.sxi_customized_add_template_5
                );
            }
            else {
				console.error("Template - 5 function not found in the loaded script");
			}

            if (typeof window.sxi_customized_add_template_6 === "function") {
                setRender_sxi_customized_add_template_6(
                    () => window.sxi_customized_add_template_6
                );
            }
            else {
				console.error("Template - 6 function not found in the loaded script");
			}

            if (typeof window.sxi_customized_add_template_7 === "function") {
                setRender_sxi_customized_add_template_7(
                    () => window.sxi_customized_add_template_7
                );
            }
            else {
				console.error("Template - 7 function not found in the loaded script");
			}
            setLoading(false);
		};

		// Handle loading errors
		script.onerror = () => {
			console.error("Failed to load the HTML renderer from CDN");
			setLoading(false);
		};

		// Add the script to the document
		document.body.appendChild(script);

		// Cleanup function to remove the script when component unmounts
		return () => {
			if (link.parentNode) link.parentNode.removeChild(link);
			if (document.body.contains(script)) document.body.removeChild(script);
		};
	}, [shop_domain]);

	// Function to render HTML content using the imported function
	const renderHtmlContent = (data) => {
		if (!sxi_customized_add_template_1_renderer && !sxi_customized_add_template_2_renderer && !sxi_customized_add_template_3_renderer && !sxi_customized_add_template_4_renderer && !sxi_customized_add_template_5_renderer && !sxi_customized_add_template_6_renderer && !sxi_customized_add_template_7_renderer) return;
		data.forEach((bot_res, bot_res_index) => {
			Object.keys(bot_res).forEach((template_ids) => {
				bot_res[template_ids].forEach((template_data, index) => {
                    let temp_html = "";
					if((template_ids === "template_1") && sxi_customized_add_template_1_renderer){
                        console.log(template_ids);
                        console.log(template_data);
                        temp_html = sxi_customized_add_template_1_renderer(template_data, `${bot_res_index}_${index}`);
					}
					if((template_ids === "template_2") && sxi_customized_add_template_2_renderer){
                        console.log(template_ids);
                        console.log(template_data);
                        temp_html = sxi_customized_add_template_2_renderer(template_data, `${bot_res_index}_${index}`);
					}
					if((template_ids === "template_3") && sxi_customized_add_template_3_renderer){
                        console.log(template_ids);
                        console.log(template_data);
                        temp_html = sxi_customized_add_template_3_renderer(template_data, `${bot_res_index}_${index}`);
					}
					if((template_ids === "template_4") && sxi_customized_add_template_4_renderer){
                        console.log(template_ids);
                        console.log(template_data);
                        temp_html = sxi_customized_add_template_4_renderer(template_data, `${bot_res_index}_${index}`);
					}
					if((template_ids === "template_5") && sxi_customized_add_template_5_renderer){
                        console.log(template_ids);
                        console.log(template_data);
                        temp_html = sxi_customized_add_template_5_renderer(template_data, `${bot_res_index}_${index}`);
					}
					if((template_ids === "template_6") && sxi_customized_add_template_6_renderer){
                        console.log(template_ids);
                        console.log(template_data);
                        temp_html = sxi_customized_add_template_6_renderer(template_data, `${bot_res_index}_${index}`);
					}
					if((template_ids === "template_7") && sxi_customized_add_template_7_renderer){
                        console.log(template_ids);
                        console.log(template_data);
                        temp_html = sxi_customized_add_template_7_renderer(template_data, `${bot_res_index}_${index}`);
					}
                    if(temp_html){
                        document.querySelector("#new_custom_template_div_preview").appendChild(temp_html);
                        // temp_html.onclick = () => {
                        //     sessionStorage.setItem("current_edit_div", temp_html.outerHTML);
                        //     window.location.href = "/editor";
                        // }
                    }
				});
			});
		});
        window.sxi_customized_template_3_helper();
	};

	// Call the render function when sxi_customized_add_template_1_renderer becomes available
	useEffect(() => {
        renderHtmlContent(suggestions_gen_data);
	}, [sxi_customized_add_template_1_renderer, sxi_customized_add_template_2_renderer, sxi_customized_add_template_3_renderer, sxi_customized_add_template_4_renderer, sxi_customized_add_template_5_renderer, sxi_customized_add_template_6_renderer, sxi_customized_add_template_7_renderer]);


	const handleSubmit = (e) => {
		e.preventDefault();
		if (input.trim()) {
			setSubmitBtnLoading(true);
            setShowChatBot(false)
			setInput(""); // clear the input field after sending

			try {
				axios
					.post(
						app_url + "/api/generate_new_suggestions_for_div",
						{
							new_message: input,
							old_message: [],
							format: "json_object",
						},
						{ withCredentials: true }
					)
					.then((res) => res.data)
					.then((data) => {
						// Simulate AI response (this should be replaced with actual API call)
						const botReply = JSON.parse(data["data"]);
						sessionStorage.setItem(
							shop_domain.replace(".myshopify.com", "") + "_sugg_gen_msg",
							JSON.stringify([...suggestions_gen_data, botReply])
						);
						renderHtmlContent([...suggestions_gen_data, botReply]);
						setSuggestionsGenData((prev) => [...prev, botReply]);
						setSubmitBtnLoading(false);
					})
					.catch((err) => {
						setSubmitBtnLoading(false);
						toast.error(`${errorMessages["AI_GENERATION_ERROR"]["title"]}`);
						console.log(err);
					});
			} catch (error) {
				toast.error(`${errorMessages["AI_GENERATION_ERROR"]["title"]}`);
				console.log(error);
			}
		}
	};

	return (
		<div className="main-container" style={{position: "relative"}}>
			{ show_chat_bot &&
                <>
                    <div style={{backgroundColor: "rgb(0 0 0 / 90%)", width: "100%", height: "100%", position: "fixed", top: "0", left:"0", zIndex: "1000000", display: "flex", justifyContent: "center", alignItems: "end", paddingBottom: "1rem"}}>
                        <button className="close-btn" onClick={() => {setShowChatBot(false)}}>
                            &times;
                        </button>
                        <Form className="input-form" onSubmit={handleSubmit}>
                            <div className="input-area">
                                <textarea
                                    ref={inputRef}
                                    rows={1}
                                    placeholder="Message Communication AI"
                                    value={input}
                                    onChange={(e) => setInput(e.target.value)}
                                    onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSubmit(e); } }}
                                />
                                <div>
                                    <button type="submit">
                                        <img src={send_icon} alt="Send" width={25} height={25} />
                                    </button>
                                </div>
                            </div>
                        </Form>
                    </div>
                </>
			}

			{!shop_domain ? (
				<div className="go_to_shopify_admin_div">
					<h5>!! Go to Shopify Admin and open our app !!</h5>
				</div>
			) : loading ? (
				<div className="main_conatiner_spinner">
					<Spinner animation="border" />
				</div>
			) : (
				<>
					<div className="main-title mt-4">
						<h2>AI Sections</h2>
					</div>
					<div id="new_custom_template_div_preview" className="mt-4 p-2"></div>
                    <div className="chatbot-sugg-gen-chat-icon">
                        {submit_btn_loading ? 
                            <button disabled>
                                <div className="main_conatiner_spinner">
                                    <Spinner animation="border" />
                                </div>
                            </button>
                        :
                            <Button onClick={() => setShowChatBot(true)} style={{borderRadius:'10rem', border:'none', padding:'0'}}>
                                <img src={logo} alt="AI" width={50} height={50} style={{display: 'inline-block', borderRadius: '10rem'}} />
                            </Button>
                        }
                    </div>

				</>
			)}
		</div>
	);
}

export default ChatBotSuggestionGen;
